import regex from '@xbcb/regex';
import { validEINPrefixes } from '../validEINPrefixes';

export const isValidEIN = (ein) =>
  ein &&
  (regex.einShort.test(ein) || regex.ein.test(ein)) &&
  validEINPrefixes.includes(ein.substr(0, 2));
